<template>
  <div>
    <!-- {{moduleId}} -->
    <b-row>
      <h2>{{ $t("checklist.pendencies.expired") }}</h2>
    </b-row>
    <br />
    <b-row>
      <b-col cols="9">
        <pendencies-export
          :fields="fields"
          :table-filters="tableFilters"
          :pagination-per-page="tablePerPage"
          :pendencyStatus="3"
        >
        </pendencies-export>
      </b-col>
      <b-col>
        <base-event-timer :timer.sync="eventTimer" :lastRefreshTime="lastRefreshTime"></base-event-timer>
      </b-col>
    </b-row>
    <b-row>
      <b-table
        ref="table"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
        :filter="tableFilters"
        :filter-debounce="500"
        selectable
        :select-mode="tableSelectMode"
      >
        <template slot="thead-top" slot-scope="{ fields }">
          <b-tr>
            <b-th v-for="field in fields" :key="field.key">
              <div v-if="tableFilters[field.key] != null">
                <div
                  v-if="field.filterKey == 'creationDate'"
                  class="dateFilter"
                >
                  <base-filter-date
                    ref="baseFilterDate"
                    :dateFill.sync="tableFilters.createDate"
                    :dateBegin.sync="tableFilters.dateCreateBegin"
                    :dateEnd.sync="tableFilters.dateCreateEnd"
                    :filterName.sync="field.label"
                    :optionFilterDate.sync="optionFilterDate"
                    v-model="tableFilters[field.key]"
                  ></base-filter-date>
                </div>
                <b-form-input
                  v-else
                  v-model="tableFilters[field.key]"
                  :placeholder="'Buscar por ' + field.label"
                />
              </div>
            </b-th>
          </b-tr>
        </template>
        <template v-slot:cell(checklistId)="data">
          <!-- {{data.item.checklistId}} -->
          <router-link
            :to="'/checklist/form/filled/details/' + data.item.checklistId"
          >
            <p>
              <u>
                {{ data.value }}
              </u>
            </p>
          </router-link>
        </template>
        <template v-slot:cell(action)="data">
          <!-- {{data.item.id}} -->
          <div v-if="moduleId">
            <router-link
              v-if="data.item.approvalDate != null"
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="
                '/module/pendencies/PedenciesDetails/' +
                data.item.id +
                '/' +
                moduleId
              "
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
          <div v-else>
            <router-link
              v-if="data.item.approvalDate != null"
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">{{ $t("checklist.form.Details") }}</b-button>
            </router-link>
            <router-link
              v-else
              :to="'/checklist/Layout/form/PedenciesDetails/' + data.item.id"
            >
              <b-button size="sm">
                {{ $t("checklist.form.Details") }}
              </b-button>
            </router-link>
          </div>
        </template>
      </b-table>
    </b-row>
    <div>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>
  </div>
</template>

<script>
import TablePaginationProps from "@/components_rms/base/TablePaginationProps.vue";
export default {
  components: {
    TablePaginationProps,
    PendenciesExport: () =>
      import("@/pagesRms/checklist/pendency/PendenciesExport.vue"),
    BaseEventTimer: () => import("@/components_rms/base/BaseEventTimer.vue"),
  },
  props: {
    moduleId: String,
  },
  data: function () {
    return {
      fields: [
        {
          key: "action",
          label: "",
          sortable: false,
          thStyle: "width: 110px",
        },
        {
          key: "id",
          label: "Pendência",
          filterKey: "id",
          sortable: false,
          thStyle: "width: 110px",
        },
        {
          key: "checklistId",
          filterKey: "checklistId",
          sortable: false,
          label: "Checklist",
          thStyle: "width: 110px",
        },
        {
          key: "formSearchKey",
          filterKey: "formSearchKey",
          sortable: true,
          label: "Chave de busca",
          thStyle: "width: 200px",
        },
        {
          key: "formName",
          filterKey: "formName",
          sortable: false,
          label: "Formulário",
        },
        {
          key: "creationDate",
          // filterKey:"creationDate",
          sortable: false,
          label: "Criação da pendência",
          // filterType: "dateRange",
          formatter: (value, key, item) => {
            let date = new Date(value);
            return date.toLocaleString();
          },
        },
        {
          key: "pendencyDescription",
          filterKey: "pendencyDescription",
          sortable: false,
          label: "Descrição",
        },
        {
          key: "dateExpiration",
          // filterKey:"dateExpiration",
          sortable: false,
          label: "Data de expiração",
          // filterType: "dateRange",
          formatter: (value, key, item) => {
            let date = new Date(value);
            return date.toLocaleString();
          },
        },
      ],
      tableFilters: {
        currentPage: 1,
        perPage: 10,
        id: "",
        checklistId: "",
        formName: "",
        formSearchKey: "",
        pendencyCreated: "",
        pendencyDescription: "",
        dateCreateBegin: "",
        dateCreateEnd: "",
        dateExpirationBegin: "",
        dateExpirationEnd: "",
        createDate: "",
      },
      optionFilterDate: 0,
      isBusy: false,
      tableRowCount: 0,
      tableCurrentPage: 1,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableSelectMode: "single",
      tableSelectedItem: [],
      checklist: {},
      hasAttachments: false,
      optionFilterDate: 0,
      eventTimer: {
        id: 0,
        userId: 0,
        eventTimerMiliseconds: 0,
        eventTimerSeconds: 0,
        pageUrl: "",
      },
      timer: null,
      refreshTime: 0,
      lastRefreshTime: null,
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  created() {
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    init() {
      this.$refs.table.refresh();
    },
    refreshPage() {
      // if (this.eventTimer.eventTimerMiliseconds == 0) return;
      this.timer = setInterval(
        this.init,
        this.eventTimer.eventTimerMiliseconds
      );
    },
    myProvider(ctx, callback) {
      this.lastRefreshTime = new Date();
      this.isBusy = true;

      let apiFilter = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        id: ctx.filter.id,
        approvalDateBegin: ctx.filter.approvalDate,
        approvalDateEnd: ctx.filter.approvalDate,
        approvalUsername: ctx.filter.approvalUsername,
        checklistId: ctx.filter.checklistId,
        formName: ctx.filter.formName,
        formSearchKey: ctx.filter.formSearchKey,
        pendencyCreatedAtBegin: ctx.filter.pendencyCreated,
        pendencyCreatedAtEnd: ctx.filter.pendencyCreated,
        pendencyDescription: ctx.filter.pendencyDescription,
        pendencyStatus: 3,
      };

      this.$apiChecklist
        .post("/pendencies/all/", apiFilter)
        .then((response) => {
          const items = response.data.items;
          this.isBusy = false;
          this.tableRowCount = response.data.totalItems;
          callback(items);
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.isBusy = false;
            this.tableRowCount = 0;
            callback([]);
          }
        });
      return null;
    },
    exportPendency() {
      this.tableFilters.perPage = this.tablePerPage;
      this.tableFilters.currentPage = this.tableCurrentPage;
      this.tableFilters.pendencyStatus = 3;
      this.$apiChecklist
        .request({
          url: "/v2/checklist/pendencyExport/",
          method: "POST",
          data: this.tableFilters,
          responseType: "arraybuffer",
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
  },
  watch: {
    eventTimer() {
      clearInterval(this.timer);
      this.refreshPage();
    },
  },
};
</script>
<style scoped>
.vertical-align {
  vertical-align: bottom !important;
}
.rigth {
  margin-top: -60px;
  margin-left: 85%;
}
</style>